<template>
    <div>
        <ValidationObserver ref="observer">
            <form ref="form" slot-scope="{ validate }" @submit.prevent="validate().then(submit)" v-on:keyup.enter="validate().then(submit)">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>{{ $t('ncrypt.my_details') }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content>
                        <ion-list>
                            <ion-item lines="none">
                                <ion-label position="floating">{{ $t('ncrypt.email') }}</ion-label>
                                <ion-label position="floating" slot="end">
                                    <small>{{ $t('ncrypt.not_editable') }}</small>
                                </ion-label>
                                <ion-input inputmode="text" type="text"
                                           disabled
                                           :value="email"
                                           :placeholder="$t('ncrypt.email')">
                                </ion-input>
                            </ion-item>
                            <ion-item lines="none" v-if="!emailVerified" slot="">
                                <ion-note class="error ion-no-padding" slot="end" button @click="$router.push({name: 'verify-emailaddress'})">{{ $t('ncrypt.email_not_yet_confirmed') }}</ion-note>
                            </ion-item>
                        </ion-list>
                        <ValidationProvider rules="required|min:2|max:40" name="first_name" v-slot="{ errors }">
                            <ion-item>
                                <ion-label position="floating">{{ $t('ncrypt.first_name') }}</ion-label>
                                <ion-input v-model="first_name" inputmode="text" type="text"
                                           :value="first_name" ref="firstName" @input="updateFirstName"
                                           :color="errors.length ? 'danger' : ''"
                                           :placeholder="$t('ncrypt.first_name')">
                                </ion-input>
                            </ion-item>
                            <ion-item v-show="errors.length" lines="none">
                                <ion-note class="error" slot="end">{{ errors[0] }}</ion-note>
                            </ion-item>
                        </ValidationProvider>
                        <ValidationProvider rules="required|min:2|max:40" name="last_name" v-slot="{ errors }">
                            <ion-item>
                                <ion-label position="floating">{{ $t('ncrypt.last_name') }}</ion-label>
                                <ion-input v-model="last_name" inputmode="text" type="text" :value="last_name" ref="lastName"
                                           @input="updateLastName"
                                           :color="errors.length ? 'danger' : ''"
                                           :placeholder="$t('ncrypt.last_name')"></ion-input>
                            </ion-item>
                            <ion-item v-show="errors.length" lines="none">
                                <ion-note class="error" slot="end">{{ errors[0] }}</ion-note>
                            </ion-item>
                        </ValidationProvider>

                        <br/>

                        <ion-button @click="validate().then(submit)">
                            <ion-icon ios='save' md="save" slot="start"></ion-icon>

                            {{ $t('ncrypt.save_details_button') }}
                        </ion-button>
                    </ion-card-content>
                </ion-card>
            </form>
        </ValidationObserver>

        <div>
            <profile-avatar/>
        </div>
    </div>
</template>

<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import {Notifier} from "@/services/Notifier";
    import {ApiError} from "@/errors/ApiError";
    import ProfileAvatar from "@/components/account/ProfileAvatar";

    export default {
        name: "Profile",
        components: {
            ProfileAvatar,
            ValidationObserver,
            ValidationProvider,
        },
        data() {
            return {
                email: this.$store.getters.user.email,
                first_name: this.$store.getters.user.first_name,
                last_name: this.$store.getters.user.last_name,
                emailVerified: !!this.$store.getters.user.email_verified_at,
            }
        },
        methods: {
            updateFirstName() {
                this.first_name = this.$refs.firstName.value;
            },
            updateLastName() {
                this.last_name = this.$refs.lastName.value;
            },
            async submit() {
                const loader = await this.$ionic.loadingController.create({
                    message: this.$t('ncrypt.details_are_being_saved'),
                    duration: 1000000,
                });

                await loader.present();

                this.$http.post('/account/user/profile-update', {
                    first_name: this.first_name,
                    last_name: this.last_name,
                })
                    .then(async ({data}) => {
                        if (!data || !data.success) {
                            new ApiError(data);
                            return;
                        }

                        await this.$store.dispatch('refreshUser');

                        await Notifier.showToast({
                            message: this.$t('ncrypt.details_are_saved'),
                        })
                    })
                    .catch(reason => new ApiError(reason))
                    .finally(() => loader.dismiss())
            },
        }
    }
</script>
